import PatternFillType from "./charts/patternFill";

export default class ChartInfo {
    color: string;
    patternFillType: PatternFillType;
    strokeWidth: number;

    public constructor(color: string, patternFillType: PatternFillType, strokeWidth: number) {
        this.color = color;
        this.patternFillType = patternFillType;
        this.strokeWidth = strokeWidth;
    }
}
